import { bunja } from 'bunja';
import { atom } from 'jotai';
import { atomWithMutation, atomWithQuery } from 'jotai-tanstack-query';

import {
  getPromotionSubscriptionPopupApi,
  postPromotionSubscriptionApi,
  postPromotionSubscriptionPopupDismissApi,
} from '@flipster/apis/v1/user';
import { snackbar } from '@flipster/react/design-system/snackbar';

import { authBunja } from '../../shared/auth/state';

export const promotionSubscriptionBunja = bunja(() => {
  const { isCookieLoggedInAtom } = bunja.use(authBunja);
  const promotionSubscriptionPopupBaseAtom = atomWithQuery((get) => ({
    queryFn: getPromotionSubscriptionPopupApi,
    queryKey: ['getPromotionSubscriptionPopupApi'],
    enabled: get(isCookieLoggedInAtom),
  }));
  const showPromotionSubscriptionPopupAtom = atom(
    (get) => get(promotionSubscriptionPopupBaseAtom).data?.data.showPopup,
  );
  const promotionSubscriptionMutationAtom = atomWithMutation((get) => ({
    mutationFn: postPromotionSubscriptionApi,
    mutationKey: ['postPromotionSubscriptionApi'],
    onSuccess: () => {
      snackbar.success({ message: "You're all set. Stay tuned for the latest rewards and updates." });
    },
    onSettled: () => get(promotionSubscriptionPopupBaseAtom).refetch(),
  }));
  const promotionSubscriptionPopupDismissMutationAtom = atomWithMutation((get) => ({
    mutationFn: postPromotionSubscriptionPopupDismissApi,
    mutationKey: ['postPromotionSubscriptionPopupDismissApi'],
    onSettled: () => get(promotionSubscriptionPopupBaseAtom).refetch(),
  }));
  return {
    showPromotionSubscriptionPopupAtom,
    promotionSubscriptionMutationAtom,
    promotionSubscriptionPopupDismissMutationAtom,
  };
});
promotionSubscriptionBunja.debugLabel = 'promotionSubscriptionBunja';
